/**
 * Stable, unique React keys for a quick-reply list. Slot buttons have an empty payload (their label is
 * sent), and two buttons may even share a label, so the base (payload, else label) gets an occurrence
 * suffix: `Pricing`, `Pricing#2`.
 */
export function buttonKeys(buttons: readonly { payload: string; text: string }[]): string[] {
  const seen = new Map<string, number>();
  return buttons.map((b) => {
    const base = b.payload || b.text;
    const n = (seen.get(base) ?? 0) + 1;
    seen.set(base, n);
    return n === 1 ? base : `${base}#${n}`;
  });
}
